import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { loadConfig } from '@/lib/config';
import { installConsoleRing } from '@/lib/feedback/consoleRing';
import { initRum } from '@/lib/rum';
import { initAnalytics } from '@/lib/analytics';
import { App } from '@/app/App';
import '@/styles/globals.css';

async function bootstrap() {
  installConsoleRing();
  // Calculator MSW worker — opt-in for SP12.0 dev/QA. Lambda endpoints
  // arrive in SP12.1; until then this lets host wiring (CB Load) drive
  // the Calculator end-to-end without a live backend.
  if (import.meta.env.DEV && import.meta.env.VITE_CALCULATOR_MSW === '1') {
    const { worker } = await import('@/components/calculator/mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  const config = await loadConfig();
  if (config.rum) initRum(config.rum);
  // Not awaited (ADR-7): the SDK loads lazily and initAnalytics never rejects.
  void initAnalytics(config);

  const root = document.getElementById('root');
  if (!root) throw new Error('Root element not found');

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

bootstrap();
